import { render, staticRenderFns } from "./pay_notify_xcx.vue?vue&type=template&id=16284cce&scoped=true&"
import script from "./pay_notify_xcx.vue?vue&type=script&lang=js&"
export * from "./pay_notify_xcx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16284cce",
  null
  
)

export default component.exports